<template>
  <div class="surequote_finance">
    <h5>{{financePeriod / 12}} Years</h5>
    <vue-slider v-model="financePeriod" :interval="silderInterval" :min="minimumFinanceTerm" :max="FinanceSettings.FinancePeriod" :adsorb="true"></vue-slider>
    <p v-if="isInterestFree"><strong class="sf-green">No interest applied!</strong></p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { UPDATE_FINANCE_PERIOD } from '@/store/actions.type.js';

export default {
  name: 'finance-slider',
  data(){
    return {
      silderInterval: 12,
      minimumFinanceTerm: 12,
    }
  },
  computed: {
    ...mapGetters(["FinanceSettings", "CalculatorSettings"]),
    financePeriod: {
        get() {
            return this.$store.state.settings.calculatorSettings.selectedFinancePeriod;
        },
        set(value) {
            this.$store.dispatch(UPDATE_FINANCE_PERIOD, value)
        }
    },
    isInterestFree() {
      return this.CalculatorSettings.selectedFinancePeriod <= this.FinanceSettings.FinanceInterestFreePeriod;
    }
  }
}
</script>